import React from 'react';
import {
    NativeSelect,

    RichCell,

    PanelHeader,

    List,
    Cell,
    PanelHeaderButton,
    Div,

    SplitCol,
    SplitLayout,

    Button,
    SimpleCell, Switch, Spinner, Pagination, Search
} from '@vkontakte/vkui';
import axios from "axios";
import {addDays} from "@vkontakte/vkui/dist/lib/date";
import {
    AdaptivityContext,

    photo_ffc_items_key
} from "../assets/constants";
import moment from "moment";
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import * as constants from "../assets/constants";
import {Icon24ExpositionOutline, Icon24Refresh, Icon24Search} from "@vkontakte/icons";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import {current_theme} from "../index";
import StorageApi from "../api/StorageApi";
import BaseComponent from "../components/BaseComponent";
import BaseApi from "../api/BaseApi";
import CopyToClipBoard from "../assets/CopyToClipboardButton";
import {parseNumericIdFromPath} from "../utils/objectLinks";


class SaleDocs extends BaseComponent {

    state = {
        value: [addDays(new Date(), -10), new Date()],
        items: [],
        dateRangeIsOpen: false,
        monitoring_items: {},
        cnt_items: 0,
        cnt_meters: 0,
        cnt_meters_approved: 0,
        cnt_bonus: 0,
        cnt_bonus_approved: 0,
        loading: true,
        show_sub_docs: true,
        currentItemId: null,
        focusId: 0,
        append: false,
        page: 1,
        totalPages: 1,
        mainSearch: '',
        showSearch: false,
        currentStatus: '',
        labels: {
            '': 'Все',
            1: 'Загружен',
            0: 'Новый',
            2: 'Зарезервирован',
            3: 'Не зарезервирован',
            5: 'Удален',
            13: 'В работе'
        }
    }


    constructor(props) {


        super(props);
        if (this.props.father && this.props.father.state.saleDocsState) {
            this.state = this.props.father.state.saleDocsState
        }
    }

    dateChange = (e) => {

        this.setState({dateRangeIsOpen: false, loading: true, value: e, page: 1, items: [], focusId: 0})

        setTimeout(() =>
            this.getItems(this.state.mainSearch, false, 1, 0), 700)
    }
    changeCurrentStatus = (status) => {

        this.setState({loading: true, currentStatus: status, page: 1, items: [], focusId: 0})
        setTimeout(() =>
            this.getItems(this.state.mainSearch, false, 1, 0), 700)
    }

    getItems = (mainSearch = '', append, page, focusId) => {
        clearInterval(this.searchInterval);
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page;
        }
        if (mainSearch == '') {
            mainSearch = this.state.mainSearch
        }
        if (focusId === undefined) {
            focusId = this.state.focusId
        }


        this.setState({loading: true})
        const body = new FormData()
        body.append('sSearch', mainSearch)
        body.append('page', page)
        if (focusId) {
            body.append('focus_id', focusId)
        }

        const currentStatus = this.state.currentStatus
        if (currentStatus) {
            body.append('filter', currentStatus)
        }
        body.append('start', this.state.value[0].toLocaleDateString())
        body.append('end', this.state.value[1].toLocaleDateString())
        body.append('epp', AdaptivityContext.isMobile ? 10 : (this.props.current_club ? 5 : 8))
        body.append('show_sub_docs', this.state.show_sub_docs === true ? 1 : 0)

        if (this.props.current_club) {
            body.append(this.props.current_club.code, 1)
        }

        axios.post(this.props.base_url + '?app=saledocs&act=showManyJson2', body,
            {
                withCredentials: true

            }
        ).then((response) => {
            this.setState({loading: false})
            let old = this.state.items;
            if (!append) {
                old = response.data.results
            } else {
                response.data.results.map((el, i) => {
                    old.push(el)
                })
            }

            this.setState({items: old})


            this.setState({cnt_items: response.data.iTotalRecords})
            this.setState({totalPages: response.data.iTotalPages})

            if (response.data.iTotalPages * 1 > 0) {
                setTimeout(() => {
                    this.checkScroll()
                }, 500)
            }
        })
        if (this.props.current_club) {
            axios.post(this.props.base_url + '?app=saledocs&act=getMeters', body,
                {
                    withCredentials: true

                }
            ).then((response) => {
                this.setState({
                    cnt_bonus: (response.data.meters * 80).toFixed(2) + ' руб.',
                    cnt_meters: response.data.meters
                })
                if (response.data.metersConfirm) {
                    this.setState({
                        cnt_bonus_approved: (response.data.metersConfirm * 80).toFixed(2) + ' руб.',
                        cnt_meters_approved: response.data.metersConfirm
                    })
                }
            })
        }

    }

    getOne = (e, id, is_monitoring = false) => {

        const target = e && e.target
        if (target instanceof HTMLImageElement) {
            //   e.preventDefault()
            return
        }

        this.openDocById(id, is_monitoring)

    }

    openDocById = (id, is_monitoring = false) => {
        if (!id) {
            return
        }
        BaseApi.post('?app=saledocs&act=showOne', {id: id}).then((response) => {

            if (response.data && response.data.doc_data) {
                this.props.select_doc(response.data, this.props.current_club, is_monitoring)
                if (is_monitoring && this.props.father) {
                    this.props.father.setState({activePanelReportFFC: 'add_monitoring_ffc_sale_doc_panel'});//, 1000);
                }
                return
            }
            window.postMessage({
                type: 'error',
                text: (response.data && response.data.error) || 'Документ не найден',
                timeout: 5000,
            })
        }).catch(() => {
            window.postMessage({
                type: 'error',
                text: 'Документ не найден',
                timeout: 5000,
            })
        })
    }

    receiveMessage = (event) => {

        if (event.data.type != undefined) {
            if (event.data.type == "orderCreated") {
                this.getItems()
            }
        }

    }

    checkScroll = () => {
        if (AdaptivityContext.isMobile) {
            let headerMobStorage = document.getElementsByClassName('mobile-table-storage-header')

            if (!headerMobStorage || headerMobStorage.length === 0) return

            headerMobStorage = headerMobStorage[0]
            const scrolled = window.scrollY

            if (scrolled > 100 && scrolled > this.scrollPrev) {
                headerMobStorage.classList.add('out')
            } else {
                headerMobStorage.classList.remove('out')
            }
            this.scrollPrev = scrolled
        }

        if (!this.ref.current) return
        if (this.state.cnt_items * 1 <= this.state.items.length) return
        let visible = this.ref.current.getBoundingClientRect().top < window.innerHeight - 80;

        if (!this.state.loading && visible) {
            let page = this.state.page
            if (page >= this.state.totalPages * 1) return
            page++;
            this.setState({page: page})

            this.getItems(undefined, true, page)


        }
    }

    handleScroll() {
        this.checkScroll()
    }

    componentDidMount = () => {

        super.componentDidMount()
        moment.locale('ru')
        const focusId = this.props.openFromUrl ? parseNumericIdFromPath('saledocs') : 0
        if (focusId) {
            this.setState({currentItemId: focusId, focusId})
            this.openDocById(focusId)
        }
        console.log(this.props.father.state.saleDocsState)
        if (this.props.father && this.props.father.state.saleDocsState) {
            return
        }
        const data = localStorage.getItem(constants.photo_ffc_items_key);

        (async () => {
            const dataRemote = await StorageApi.getItem(constants.photo_ffc_items_key)
            if (dataRemote === "undefined" && data && data !== "undefined") {
                const items = JSON.parse(data)
                StorageApi.setItem(photo_ffc_items_key, JSON.stringify(items ?? {}))
                this.setState({monitoring_items: items})
            } else {

                if (dataRemote && dataRemote !== "undefined") {
                    const items = JSON.parse(dataRemote)
                    this.setState({monitoring_items: items})
                }

            }
            this.getItems('', false, 1, focusId)
        })()
    }
    componentWillUnmount = () => {
        super.componentWillUnmount()
        localStorage.setItem(photo_ffc_items_key, JSON.stringify(this.state.monitoring_items ? this.state.monitoring_items : {}))
        StorageApi.setItem(photo_ffc_items_key, JSON.stringify(this.state.monitoring_items ? this.state.monitoring_items : {}))

        if (this.props.father) {
            this.props.father.setState({saleDocsState: this.state})
        }
    }

    onClick = (e, id, is_monitoring = false) => {
        e.stopPropagation()
        this.setState({currentItemId: id})
        this.getOne(e, id, is_monitoring)
    }
    setShowSubDocs = (e) => {

        this.setState({show_sub_docs: e.target.checked, page: 1, items: [], focusId: 0})

        setTimeout(() =>
            this.getItems(undefined, false, 1, 0), 700)
    }


    export2Csv = () => {


        const ajaxSrc = this.props.base_url + "/?app=saledocs&act=showManyJson2&start=" + this.state.value[0].toLocaleDateString() +
            "&end=" + this.state.value[1].toLocaleDateString() +
            `&${this.props.current_club.code}=1` +
            '&sSearch=' +
            '&show_sub_docs=' + (this.state.show_sub_docs === true ? 1 : 0) +
            '&export_excel=1' +
            '&page=' + 1;

        window.open(ajaxSrc, 'blank_');
    }
    setPage = (page) => {
        if (page <= this.state.totalPages) {
            this.setState({loading: true, page: page})
            setTimeout(() =>
                this.getItems(this.state.mainSearch, false, page), 600)
        }
    }

    toggleSearch = () => {


        this.setState({showSearch: !this.state.showSearch});

    }

    searchInterval = null;
    element = null;
    onSearchChange = (state) => {


        clearInterval(this.searchInterval);
        this.setState({mainSearch: state.target.value, focusId: 0});
        this.searchInterval = setInterval(() => {
            // console.log(state);
            this.setState({loading: true, page: 1});
            this.getItems(this.state.mainSearch, false, 1, 0);
        }, state.target.value == '' ? 500 : 2000);

    }

    render() {

        return (
            <SplitLayout>
                <SplitCol>
                    <PanelHeader fixed={true}
                                 before={AdaptivityContext.isMobile && !this.props.parent_product_id ?
                                     <PanelHeaderButton style={{display: 'inline'}}
                                                        onClick={this.toggleSearch}><Icon24Search/></PanelHeaderButton> : ''}
                                 after={!this.state.showSearch || !AdaptivityContext.isMobile ?
                                     <Div style={{display: "flex"}}>
                                         <DateRangePicker
                                             onCalendarClose={() => setTimeout(() => this.setState({dateRangeIsOpen: false}), 1000)}
                                             onClick={() => {
                                                 this.setState({dateRangeIsOpen: true});
                                                 console.log(this.state.dateRangeIsOpen)
                                             }}
                                             showLeadingZeros={true}
                                             value={this.state.value}
                                             isOpen={this.state.dateRangeIsOpen}
                                             key="SaleDocsDateRangePicker"
                                             onChange={this.dateChange}/>
                                         <Button size="s" mode="tertiary" style={{maxWidth: "42px"}} onClick={() => {
                                             this.setState({page: 1, items: []});
                                             this.getItems(this.state.mainSearch, false, 1)
                                         }}><Icon24Refresh/></Button>
                                     </Div> : ''}
                    >
                        <Div>
                            {this.state.showSearch || !AdaptivityContext.isMobile ?
                                <form onSubmit={e => {
                                    e.preventDefault();
                                    e.stopPropagation()
                                }}>
                                    <Search autoFocus

                                            theme="header"
                                            placeholder="Поиск"
                                            value={this.state.mainSearch}
                                            onChange={this.onSearchChange}
                                            onClose={this.toggleSearch}

                                            style={{flexGrow: '1', maxWidth: '350px'}}
                                    /></form> : AdaptivityContext.isMobile ? '' : 'Заказы'

                            }

                        </Div>
                    </PanelHeader>
                    <div
                        className={AdaptivityContext.isMobile ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
                        <SplitLayout>
                            <SplitCol>
                                <SimpleCell Component="label" multiline
                                            after={<Switch size={5} checked={this.state.show_sub_docs}
                                                           onChange={this.setShowSubDocs}/>}>
                                    Показывать не свои документы
                                </SimpleCell>
                                <Div style={{display: this.props.current_club ? 'inherit' : 'none'}}>
                                    <Button before={<Icon24ExpositionOutline/>} onClick={() => this.export2Csv()}>Экспорт
                                        в
                                        Excel</Button>
                                </Div>
                            </SplitCol>
                            <SplitCol>
                                <Div className="all-docs-block">
                                <span className="all-docs"
                                      id="cnt_items">Всего документов: {this.state.cnt_items}</span>
                                    <span className="all-docs" id="status" style={{height: '30px'}}>
                                 <NativeSelect
                                     style={{
                                         zIndex: 6,
                                         marginLeft: '10px',
                                         height: '30px',
                                         maxWidth: AdaptivityContext.isMobile && this.props.monitoring_mode ? '150px' : 'inherit'
                                     }}
                                     value={this.state.currentStatus}
                                     onChange={(e) => this.changeCurrentStatus(e.target.value)}
                                 >
                                    {Object.keys(this.state.labels).map((itemP, indexP) => (
                                        <option value={itemP}>{this.state.labels[itemP]}</option>
                                    ))}</NativeSelect>
                                </span>
                                    {this.props.current_club && (this.props.current_club.code == 'is_betta_' || this.props.current_club.code == 'is_lq') ?
                                        <div>

                                            <span className="all-docs"
                                                  style={{display: this.props.current_club ? 'inherit' : 'none'}}
                                                  id="cnt_meters">Всего заказано м2: {this.state.cnt_meters}. Бонус: {this.state.cnt_bonus}</span>
                                            <span className="all-docs"
                                                  style={{display: this.props.current_club ? 'inherit' : 'none'}}
                                                  id="cnt_meters">Подверждено м2: {this.state.cnt_meters_approved}. Бонус: {this.state.cnt_bonus_approved}</span>


                                        </div> :
                                        <div>
                                            <span className="all-docs"
                                                  style={{display: this.props.current_club ? 'inherit' : 'none'}}
                                                  id="cnt_meters">Всего кв. метров: {this.state.cnt_meters}</span>
                                            {this.props.current_club && this.props.current_club.code !== 'is_primavera' &&
                                                <span className="all-docs"
                                                      style={{display: this.props.current_club ? 'inherit' : 'none'}}
                                                      id="cnt_bonus">Бонус: {this.state.cnt_bonus}</span>}
                                        </div>
                                    }
                                </Div>
                            </SplitCol>
                        </SplitLayout>
                    </div>
                    {!this.state.loading && Array.isArray(this.state.items)
                        && this.state.items.length === 0 && <Cell key={'notFound' + 0}>Ничего не найдено</Cell>}
                    {this.state.items.map((item, index) => {


                        return [<SplitLayout>
                            <SplitCol width={1}>
                                <RichCell bottom={<div>{item.user.name}</div>} multiline
                                          subhead={item.date + ' ' + item.time}
                                          onClick={(e) => this.onClick(e, item.id)}>
                                    {item.nomer}
                                </RichCell>
                            </SplitCol>
                            <SplitCol width={110}>
                                <List>
                                    {Array.isArray(item.childs) ? item.childs.map((child, index2) => {


                                        const confirmFFC = child.meta && child.meta.confirmFFC ? child.meta.confirmFFC : false;
                                        let ffc_confirmation = confirmFFC

                                        let can_confirm = (child.user_id == this.props.current_user.id || child.is_manager)

                                        if (this.props.current_club && (this.props.current_club.code == 'is_betta_' || this.props.current_club.code == 'is_lq')) {
                                            can_confirm = this.props.current_user && this.props.current_user['meta'] && this.props.current_user['meta']['settings']
                                                && (this.props.current_user['meta']['settings']['admin_betta_club'] || this.props.current_user['meta']['settings']['admin_lq_club'])
                                        }

                                        /*                                        if (confirmFFC && this.state.monitoring_items[child.id]) {
                                                                                    ffc_confirmation = (this.state.monitoring_items[child.id])

                                                                                }*/

                                        //console.log(ffc_confirmation)

                                        return <RichCell onClick={(e) => this.onClick(e, child.id)} multiline
                                                         style={{
                                                             background: (this.props.current_club &&
                                                             ffc_confirmation !== undefined && ffc_confirmation.image ? 'inherit' : (this.props.current_club ?
                                                                 (current_theme == 'dark' ? '#444400' : '#d4d409')
                                                                 : 'inherit'))
                                                         }}
                                                         bottom={[
                                                             ((child.is_firm_fit || child.is_primavera || child.is_betta_ || child.is_lq) && this.props.current_club ?
                                                                 <div className="sale-docs_ffc-info-wrapper">
                                                                     {this.props.current_club && this.props.current_club.code != 'is_betta_' && this.props.current_club.code != 'is_lq' &&
                                                                         <div>
                                                                             <span style={{fontSize: 'smaller'}}>Установлена защита сделки <b>{this.props.current_club.name}</b> до {child.day_protect}</span>
                                                                             <span
                                                                                 style={{fontSize: 'smaller'}}>Адрес объекта: {child.meta.protect_address}</span>
                                                                             <span
                                                                                 style={{fontSize: 'smaller'}}>Телефон: {child.meta.protect_phone}</span>
                                                                         </div>
                                                                     }
                                                                     {this.props.current_club && (this.props.current_club.code == 'is_betta_' || this.props.current_club.code == 'is_lq') &&
                                                                         <span
                                                                             style={{fontSize: 'smaller'}}>Телефон monarh-bonus: {child.meta.monarch_bonus_phone}</span>

                                                                     }
                                                                     <span
                                                                         style={{fontSize: 'smaller'}}>ФИО: {child.meta.protect_fio}</span>

                                                                 </div>
                                                                 : ''),

                                                             this.props.current_club && can_confirm ? (
                                                                 ffc_confirmation !== undefined && ffc_confirmation.image ?
                                                                     [<Button
                                                                         onClick={(e) => this.onClick(e, child.id, true)}>Изменить
                                                                         подтверждение отгрузки</Button>,
                                                                         <span style={{fontSize: 'smaller'}}>Подтверждение отгрузки: <b>{ffc_confirmation.numdoc}</b> от {ffc_confirmation.date}</span>
                                                                     ] :
                                                                     <Button
                                                                         onClick={(e) => this.onClick(e, child.id, true)}>Подтвердить
                                                                         отгрузку</Button>
                                                             ) : '', <hr/>,

                                                             (child.meters && this.props.current_club &&
                                                                 (this.props.current_club.code == 'is_betta_' || this.props.current_club.code == 'is_lq' ?
                                                                         <div style={{
                                                                             display: "flex",
                                                                             flexDirection: 'column'
                                                                         }}>
                                                                             <span style={{fontSize: 'smaller'}}>
                                                                                 Всего заказано м2:<b>{child.meters}</b>. Бонус:<b>{(child.meters * 80).toFixed(2)}</b></span>
                                                                             {child.metersConfirm &&
                                                                                 <span style={{fontSize: 'smaller'}}>
                                                                                 Подверждено м2: <b>{child.metersConfirm}</b>. Бонус: <b>{(child.metersConfirm * 80).toFixed(2)}</b></span>}
                                                                         </div>
                                                                         : <div style={{
                                                                             display: "flex",
                                                                             flexDirection: 'column'
                                                                         }}>
                                                                             <span
                                                                                 style={{fontSize: 'smaller'}}>{child.meters}м2</span>
                                                                             {this.props.current_club &&
                                                                                 this.props.current_club.code !==
                                                                                 'is_primavera' &&
                                                                                 <span
                                                                                     style={{fontSize: 'smaller'}}><b>Бонус</b>: {(child.meters * 80).toFixed(2)} руб.</span>}
                                                                         </div>
                                                                 )),
                                                             this.props.current_club && this.props.current_club.code != 'is_betta_' && this.props.current_club.code != 'is_lq' || !this.props.current_club &&
                                                             <Button size="s">{child['1CStatusName']}</Button>
                                                             ,
                                                             <hr/>,
                                                             child.meta && child.meta.СкладПолучения && child.meta.СкладПолучения.Представление ? `Филиал: ${child.meta.СкладПолучения.Представление}` : ''
                                                         ]
                                                         }
                                                         subhead={<span
                                                             style={{fontSize: 'smaller'}}>{child.date} {child.time}</span>}
                                                         after={(child.total * 1).toFixed(2)}>
                                            {child.NomerDocKIS ? [child.NomerDocKIS,
                                                <CopyToClipBoard style={{marginTop: '0px', minWidth: '36px'}}
                                                                 text={child.NomerDocKIS}/>] : 'Номер в 1С еще не получен'}

                                        </RichCell>
                                    }) : ''}
                                </List>
                            </SplitCol>
                        </SplitLayout>,

                            <hr/>]
                    })}
                    <div
                        ref={this.ref}
                        key="loader"
                        style={{height: AdaptivityContext.isMobile ? '50px' : '140px', width: 'auto'}}
                    >
                        {this.state.loading ?
                            <Cell before="Запрашиваем данные с сервера"
                                  after={<Spinner size="large"/>}></Cell> : ""}
                    </div>
                    {this.state.totalPages > 1 && !AdaptivityContext.isMobile ?
                        <div style={{background: "whitesmoke", position: "fixed", bottom: "52px", zIndex: '99'}}>
                            <Pagination currentPage={this.state.page}
                                        totalPages={this.state.totalPages}
                                        onChange={this.setPage}/>
                        </div> : ''}
                </SplitCol>
            </SplitLayout>
        )
    }

}

export default SaleDocs